import { render } from "./DirectivesDetailPage.vue?vue&type=template&id=0781e6c7&scoped=true"
import script from "./DirectivesDetailPage.vue?vue&type=script&lang=js"
export * from "./DirectivesDetailPage.vue?vue&type=script&lang=js"

import "./DirectivesDetailPage.vue?vue&type=style&index=0&id=0781e6c7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0781e6c7"]])

export default __exports__